import React, { useState } from "react";
import NavBar from "../NavBar";
import CareerInterestSurvey from "./CareerSurvey/CareerInterestSurvey";
import ProgramSearch from "./ProgramSearch/ProgramSearch";
import ExtracurricularRecommendations from "./CareerSearch/ExtracurricularRecommendations";


function CareerPage() {
  const [activeTab, setActiveTab] = useState("survey");

  const tabClasses = (tab) =>
    `inline-block px-4 py-2.5 border-b-2 rounded-t-lg ${
      activeTab === tab
        ? "text-blue-600 border-blue-600"
        : "hover:text-gray-600 hover:border-gray-300"
    }`;

  return (
    <div className="w-full min-h-screen bg-white mt-5">
      <NavBar />
      <div className="container mx-auto mt-10">
        {/* Tabs Navigation */}
        <div className="border-b border-gray-200">
          <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" role="tablist">
            <li className="mr-2" role="presentation">
              <button
                className={tabClasses("survey")}
                type="button"
                role="tab"
                onClick={() => setActiveTab("survey")}
              >
                Career Interest Survey
              </button>
            </li>
            <li className="mr-2" role="presentation">
              <button
                className={tabClasses("programsearch")}
                type="button"
                role="tab"
                onClick={() => setActiveTab("programsearch")}
              >
                Program Recommendations
              </button>
            </li>
            <li role="presentation">
              <button
                className={tabClasses("extracurricular")}
                type="button"
                role="tab"
                onClick={() => setActiveTab("extracurricular")}
              >
                Extracurricular Recommendations
              </button>
            </li>
          </ul>
        </div>

        {/* Tab Panels */}
        {activeTab === "survey" && <CareerInterestSurvey />}
        {activeTab === "programsearch" && (
          <ProgramSearch onTakeSurvey={() => setActiveTab("survey")} />
        )}
        {activeTab === "extracurricular" && <ExtracurricularRecommendations />}
      </div>
    </div>
  );
}

export default CareerPage;
